module.exports = __webpack_public_path__ + "static/media/emptybag.e50afedc.png";